module.exports = __webpack_public_path__ + "img/login.848dc1b3.png";